module.exports = __webpack_public_path__ + "static/media/star.cfa13585.svg";